
export default {
    namespaced:true,
    state:{
        jsonCurso:[],
        activeCurso:'',
        titulosCurso:[],
        jsonUltimosCursos:[],
        searchCurso:[],
        currentSelector:"disponibles",
        globalLoadingMulticampus:false,
        campusSeleccionadoMulti: JSON.parse(localStorage.getItem("campusSeleccionadoMulti")) != null ? JSON.parse(localStorage.getItem("campusSeleccionadoMulti")) : []
    },
    mutations:{
        updateGlobalLoadingMulticampusAction(state,payload){
           state.globalLoadingMulticampus = payload;
        },
        cambioJsonCurso(state,payload){
            state.jsonCurso = payload;
        },
        cambioJsonUltimos(state,payload){
            state.jsonUltimosCursos = payload;
        },
        updateActiveCurso(state,payload){
            state.activeCurso = payload
        },
        updateTitulosCurso(state,payload){
            state.titulosCurso = payload;
        },
        setJsonCurso(state,payload){
            state.jsonCurso.push(payload);
        },
        updateCursoSearch(state, payload){
            state.searchCurso = payload;
        },
        updateCurrentSelector(state, payload){
            state.currentSelector = payload;
        },
        updateLargoDisponibles(state, payload){
            state.titulosCurso.largoActualDisponibles = payload;
        },
        updateCurrentArchivados(state, payload){
            state.titulosCurso.largoActualArchivados = payload;
        },
        updateTotalAlumnosCampus(state, payload){
            state.titulosCurso.totalAlumnos = payload;
        },
        setCampusSeleccionadoMulti(state,payload){
            localStorage.setItem("campusSeleccionadoMulti",JSON.stringify(payload));
            state.campusSeleccionadoMulti = payload;
        },
        filterCursosByCampus(state,payload){

            let cursosDisponibles = [];  
			let cursosArchivados = [];
			payload.titulosCurso.listadoCursos.map((curso) => {
				if(curso.archivado == 0){
                    if(payload.filter){
                        if(curso.tituloCampus == payload.campusSeleccionado.titulo){
                            cursosDisponibles.push({
                                idCurso: curso.idCurso,
                                curso: curso.tituloCurso,
                                campus: curso.tituloCampus,
                                fechaInicio: curso.fechaInicio,
                                cantidadAlumnos: curso.cantidadAlumnos
                            });
                        }
                    }else{
                        cursosDisponibles.push({
                            idCurso: curso.idCurso,
                            curso: curso.tituloCurso,
                            campus: curso.tituloCampus,
                            fechaInicio: curso.fechaInicio,
                            cantidadAlumnos: curso.cantidadAlumnos
                        });
                    }
                    
				}else if(curso.archivado == 1 && curso.tituloCampus == payload.campusSeleccionado.titulo){
                    if(payload.filter){
                        if(curso.tituloCampus == payload.campusSeleccionado.titulo){
                            cursosArchivados.push({
                                idCurso: curso.idCurso,
                                curso: curso.tituloCurso,
                                campus: curso.tituloCampus,
                                fechaInicio: curso.fechaInicio,
                                cantidadAlumnos: curso.cantidadAlumnos
                            });
                        }
                    }else{
                        cursosArchivados.push({
                            idCurso: curso.idCurso,
                            curso: curso.tituloCurso,
                            campus: curso.tituloCampus,
                            fechaInicio: curso.fechaInicio,
                            cantidadAlumnos: curso.cantidadAlumnos
                        });
                    }
				}
			});

            let totalxCampus = payload.titulosCurso.listadoCursos.map((lc)=>{
                if(payload.filter){
                    if(payload.campusSeleccionado.titulo == lc.tituloCampus){
                        return lc.cantidadAlumnos;
                    }
                }else{
                    return lc.cantidadAlumnos;
                }
             }).filter((f)=>f!=undefined);

			const titulosCurso = {
				listadoCursos: payload.titulosCurso.listadoCursos,
				totalAlumnos: totalxCampus.reduce((a, b) => a + b, 0),
				totalCursos: cursosArchivados.length + cursosDisponibles.length,
				cursosArchivados,
				cursosDisponibles,
				largoActualDisponibles:cursosDisponibles.length,
				largoActualArchivados:cursosArchivados.length,
				totalCampus:payload.titulosCurso.totalCampus
			};
            state.titulosCurso = titulosCurso;
            state.jsonCurso = cursosDisponibles;

        },
    },
    actions:{
        filterCursosByCampusAction({commit},payload){
            commit('filterCursosByCampus',payload)
        },
        setCampusSeleccionadoMultiAction({commit},payload){
            commit('setCampusSeleccionadoMulti',payload)
        },
        updateLargoDisponiblesAction({commit},payload){
            commit('updateLargoDisponibles',payload)
        },
        updateCurrentArchivadosAction({commit},payload){
            commit('updateCurrentArchivados',payload)
        },
        updateTotalAlumnosCampusAction({commit},payload){
            commit('updateTotalAlumnosCampus',payload)
        },
        updateOnlyCurso({commit},payload){
            commit('cambioJsonCurso',payload)
        },
        updateCursoSearch({commit},payload){
            commit('updateCursoSearch',payload)
        },
        updateUltimosCursos({commit},payload){
            commit('cambioJsonUltimos',payload)
        },
        updateActiveCurso({commit},payload){
            commit('updateActiveCurso',payload)
        },
        updateTitulosCurso({commit},payload){
            commit('updateTitulosCurso',payload)
        },
        setJsonCurso({commit},payload){
            commit('setJsonCurso',payload)
        },
        setCurrentSelector({commit},payload){
            commit('updateCurrentSelector',payload)
        },
        updateGlobalLoadingMulticampus({commit},payload){
            commit('updateGlobalLoadingMulticampusAction',payload);
        }

    },
    getters:{
       
    }
}